import { useMemo } from "react";
import { Table, Text } from "@mantine/core";
import type {
  LegacyExtractionSummary,
  LegacySourceFields,
} from "../../../types/legacyCases";

interface Props {
  spreadsheet: LegacySourceFields;
  extraction?: LegacyExtractionSummary;
}

export default function LegacySourceComparison({
  spreadsheet,
  extraction,
}: Props) {
  const fields = useMemo(
    () => [
      {
        key: "patientName",
        label: "Patient name",
        value: `${spreadsheet.lastName}, ${spreadsheet.firstName} ${
          spreadsheet.middleInitial || ""
        }`.trim(),
      },
      {
        key: "dateOfBirth",
        label: "Date of birth",
        value: spreadsheet.dateOfBirth,
      },
      { key: "sex", label: "Sex", value: spreadsheet.sexRaw },
      {
        key: "caseNumber",
        label: "Case number",
        value: spreadsheet.caseNumber,
      },
      {
        key: "dateReceived",
        label: "Date received",
        value: spreadsheet.dateReceived,
      },
      {
        key: "reportedDate",
        label: "Reported date",
        value: spreadsheet.reportedDate,
      },
      { key: "physician", label: "Physician", value: undefined },
    ],
    [spreadsheet]
  );
  return (
    <Table.ScrollContainer minWidth={400}>
      <Table verticalSpacing="sm">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Field</Table.Th>
            <Table.Th>Spreadsheet</Table.Th>
            <Table.Th>Final report</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {fields.map(({ key, label, value }) => (
            <Table.Tr key={key}>
              <Table.Td>{label}</Table.Td>
              <Table.Td>
                <Text size="sm" style={{ overflowWrap: "anywhere" }}>
                  {value || "Not provided"}
                </Text>
              </Table.Td>
              <Table.Td>
                <Text
                  size="sm"
                  style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
                >
                  {extraction?.result.fields[key]
                    ?.map((field) => field.rawValue)
                    .join("\n") ||
                    (extraction
                      ? "Not identified; review the PDF"
                      : "Extract the report to compare")}
                </Text>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
